export const getSelectorStyling = (width = 85) => ({
  minWidth: width,
  '& .MuiSelect-select': {
    fontSize: '0.75rem',
    padding: '8px 32px 8px 12px',
    minHeight: 'auto',
    display: 'flex',
    alignItems: 'center'
  },
  '& .MuiOutlinedInput-root': {
    height: 32,
    fontSize: '0.75rem'
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.7rem',
    transform: 'translate(11px, -7px) scale(0.9)'
  },
  '& .MuiSelect-icon': {
    fontSize: '1.1rem',
    right: 8
  }
});

export const getMenuItemStyling = () => ({
  fontSize: '0.75rem',
  minHeight: 28,
  paddingTop: '4px',
  paddingBottom: '4px'
});
